// removed by extract-text-webpack-plugin
module.exports = {"root":"_1H-uK77","savePrompt":"_3ZUC17O","saveDescription":"_3AeDpFL"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMailOld/JobMailWrapper.less
 ** module id = 884
 ** module chunks = 0
 **/